import { useCallback, useState } from 'react'
import { OptionTypeBase } from 'react-select'
import { FormikHelpers } from 'formik'

import { TRANSACTION_TYPES } from 'constants/filters'
import { formatDateToShort } from 'services/helpers'
import {
  TransactionFilterFormSubmitValuesTypes,
  TransactionFilterFormTypes,
} from 'types/transactions'
import useTransactionStore from 'store/transaction'

const today = new Date()
const thirteenMonthsAgo = new Date()
thirteenMonthsAgo.setMonth(thirteenMonthsAgo.getMonth() - 13)
const defaultStartDate = thirteenMonthsAgo
const TransactionFilterINITVAL: TransactionFilterFormTypes = {
  transactionType: TRANSACTION_TYPES[0],
  merchant: '',
  startDateRange: defaultStartDate,
  endDateRange: today,
}

const useTransactionsFilter = ({ memberTraderId }: { memberTraderId: string }) => {
  const [startDate, setStartDate] = useState<Date | null>(defaultStartDate)
  const [endDate, setEndDate] = useState<Date | null>(today)
  const [selectedMerchant, setSelectedMerchant] = useState<OptionTypeBase | null>(null)
  const [merchantId, setMerchantId] = useState<number>()
  const [filterStartDate, setFilterStartDate] = useState<string>()
  const [filterEndDate, setFilterEndDate] = useState<string>()
  const [transactionTypeId, setTransactionTypeId] = useState<number>()

  const transactionsLoading = useTransactionStore((state) => state.transactionsLoading)
  const getTransactions = useTransactionStore((state) => state.getTransactions)
  const isFilteredTransactions = useTransactionStore((state) => state.isFilteredTransactions)
  const setFilteredTransactionsStatus = useTransactionStore((state) => state.setFilteredTransactionsStatus)

  const initialValues: TransactionFilterFormTypes = {
    ...TransactionFilterINITVAL,
    startDateRange: startDate || defaultStartDate,
    endDateRange: endDate || today,
  }

  const handleTransactionFilter = useCallback(
    async (
      values: TransactionFilterFormSubmitValuesTypes,
      actions: FormikHelpers<TransactionFilterFormSubmitValuesTypes>
    ) => {
      setMerchantId(parseInt(selectedMerchant?.value))
      setFilterStartDate(formatDateToShort(startDate || defaultStartDate))
      setFilterEndDate(formatDateToShort(endDate || today))
      setTransactionTypeId(parseInt(values.transactionType.value))

      const queryStartDate = formatDateToShort(startDate || defaultStartDate)
      const queryEndDate = formatDateToShort(endDate || today)
      const queryTransactionTypeId =
        values.transactionType.value === '0' ? undefined : values.transactionType.value
      const merchantIdValue = values.merchant

      actions.setSubmitting(false)
      await getTransactions(
        memberTraderId,
        undefined,
        queryTransactionTypeId,
        merchantIdValue,
        queryStartDate,
        queryEndDate
      )
      setFilteredTransactionsStatus(true)
    },
    [selectedMerchant, startDate, endDate, getTransactions, memberTraderId]
  )

  const handleTransactionFilterClear = useCallback(async () => {
    await getTransactions(memberTraderId)
    setFilteredTransactionsStatus(false)
  }, [getTransactions, memberTraderId])

  return {
    handleTransactionFilter,
    handleTransactionFilterClear,
    merchantId,
    filterStartDate,
    setFilterStartDate,
    filterEndDate,
    setFilterEndDate,
    transactionTypeId,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    selectedMerchant,
    setSelectedMerchant,
    initialValues,
    isFilteredTransactions,
    transactionsLoading,
  }
}

export default useTransactionsFilter
